import { memo } from "react";

import {
  type PaginationData,
  type PaginationItem,
  type Splide,
} from "@splidejs/splide";

import {
  PAGINATION_ACTIVE_CLASS,
  PAGINATION_INACTIVE_CLASS,
} from "@react/components/Carousel/constants";
import { tw, type TTailwindString } from "classnames";

interface Props {
  className?: TTailwindString;
}

const styles = {
  wrapper: (className?: TTailwindString) =>
    tw(
      "splide__pagination" as TTailwindString,
      "m-0",
      "list-none",
      "p-0",
      className ? tw(className) : undefined
    ),
};

const CarouselPaginationDotsBase = ({ className }: Props) => (
  <ul className={styles.wrapper(className)}></ul>
);

export const onPaginationUpdated = (
  Splide: Splide,
  data: PaginationData,
  prev: PaginationItem,
  curr: PaginationItem
) => {
  prev.button.classList.add(PAGINATION_INACTIVE_CLASS);
  prev.button.classList.remove(PAGINATION_ACTIVE_CLASS);

  curr.button.classList.add(PAGINATION_ACTIVE_CLASS);
  curr.button.classList.remove(PAGINATION_INACTIVE_CLASS);
};

export const CarouselPaginationDots = memo(CarouselPaginationDotsBase);
